// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'inter', 'inter Fallback'"},"className":"__className_faccaa","variable":"__variable_faccaa"};